module.exports = __webpack_public_path__ + "img/order_dinein.1fdb8c71.svg";